import {
    LIST_INHIBITION_TYPES,
    LIST_INHIBITION_TYPES_SUCCESS,
    LIST_INHIBITION_TYPES_ERROR,
    ADD_INHIBITION_TYPES,
    SAVE_INHIBITION_TYPES,
    SAVE_INHIBITION_TYPES_SUCCESS,
    SAVE_INHIBITION_TYPES_ERROR,
    EDIT_INHIBITION_TYPES,
    UPDATE_INHIBITION_TYPES,
    UPDATE_INHIBITION_TYPES_SUCCESS,
    UPDATE_INHIBITION_TYPES_ERROR,
    DELETE_INHIBITION_TYPES,
    DELETE_INHIBITION_TYPES_SUCCESS,
    DELETE_INHIBITION_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    inhibitionTypes: null,
    error: null,
    loading: false,
    inhibitionTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_INHIBITION_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_INHIBITION_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_INHIBITION_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                inhibitionTypes: action.payload
            }
        case SAVE_INHIBITION_TYPES:
        case DELETE_INHIBITION_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_INHIBITION_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_INHIBITION_TYPES_ERROR:
        case UPDATE_INHIBITION_TYPES_ERROR:
        case DELETE_INHIBITION_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_INHIBITION_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                inhibitionTypes: [...state.inhibitionTypes, action.payload]
            }
        case ADD_INHIBITION_TYPES:
            return {
                ...state,
                inhibitionTypeSelected: null,
                isEdit: false
            }
        case EDIT_INHIBITION_TYPES:
            return {
                ...state,
                inhibitionTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_INHIBITION_TYPES_SUCCESS:
        case DELETE_INHIBITION_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                inhibitionTypes: state.inhibitionTypes.map(inhibitionType => 
                    inhibitionType.id === action.payload.id ? inhibitionType = action.payload : inhibitionType
                ),
                inhibitionTypeSelected: null
            }
        // case DELETE_INHIBITION_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         inhibitionTypes: state.inhibitionTypes.filter( inhibitionType => inhibitionType.id !== action.payload)
        //     }
        default:
            return state;
    }
}